import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { AtlasConfig } from 'garaje/utils/atlas';

interface AtlasEditorPanelLocaleComponentProps {
  config: AtlasConfig;
}

export default class AtlasEditorPanelLocaleComponent extends Component<AtlasEditorPanelLocaleComponentProps> {
  @tracked localeOptions: { id: string; name: string }[] = [
    {
      name: 'English',
      id: 'en',
    },
    {
      name: 'Español',
      id: 'es',
    },
    {
      name: 'Français',
      id: 'fr',
    },
    {
      name: 'Română',
      id: 'ro',
    },
  ];
}
